<template>
    <add-edit-country></add-edit-country>
</template>

<script>
import AddEditCountry from "@/layouts/components/masters/countries/addedit-country.vue";
export default {
 components : {
   AddEditCountry
 },
};
</script>